export const PROMOCODE_VIEW = {
  START: 'start',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  SERVER_ERROR: 'server-error',
}
export const PROMOCODE_REASONS = {
  MANY_REQUESTS: 'To many requests',
  NOT_FOUND: 'Promocode not found',
  INVALID_CODE: 'Invalid code. Expected string',
  ALREADY_USED: 'User already has promotions by promocode',
  OVER_ACTIVATIONS: 'Over activations',
  SERVER_ERROR: 'Server error',
}

export const promocodeConfig = {

  [PROMOCODE_VIEW.WARNING]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.warn.title',
    text: 'promoCode.popup.warn.text',
  },
  [PROMOCODE_VIEW.SUCCESS]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.success.title',
    text: 'promoCode.popup.success.text',
  },

  [PROMOCODE_VIEW.SUCCESS_CASHBOX]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.successCashbox.title',
    text: 'promoCode.popup.successCashbox.text',
  },
  [PROMOCODE_VIEW.START]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.startView.title',
    text: 'promoCode.popup.startView.text',
  },
  [PROMOCODE_VIEW.ERROR]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.startView.title',
    text: 'promoCode.popup.startView.text',
  },
  [PROMOCODE_VIEW.SERVER_ERROR]: {
    src: '/img/promocode/icon.png',
    title: 'promoCode.popup.serverError',
    text: 'promoCode.popup.serverError',
  },
  default: {
    src: '/img/promocode/icon.png',
  },
}
